import Swiper from "swiper/bundle";

class CarouselLoadIE {
  constructor(carouselId, config) {
    this.carouselId = carouselId;
    this.$carousel = document.querySelector(this.carouselId);
    this.$carousel.classList.add("ie");
    this.path = this.$carousel.dataset.contentUrl;
    this.listName = this.$carousel.dataset.listName;
    this.carousel = new Swiper(this.$carousel, config);
    this.carousel.on("slideChange", this.update);
    this.carousel.on("init", this.removeGrid);
    this.carousel.init();
  }

  removeGrid = () => {
    this.$carousel.querySelectorAll(".swiper-slide").forEach((el) => {
      el.classList.remove("col-sm-6", "col-md-4", "col-lg-3");
    });
  };

  getNotLoaded = () => this.$carousel.querySelectorAll(".swiper-slide:not(.loaded)");

  getVisibleNotLoaded = () => this.$carousel.querySelectorAll(".swiper-slide-visible:not(.loaded)");

  getByItemId = (itemId) => this.$carousel.querySelectorAll(`.js-carousel-item-${itemId}`);

  loadItems = (params) => $.get(this.path, params);

  update = () => {
    if (this.carousel.initialized) {
      if (this.getNotLoaded().length === 0) {
        this.carousel.off("slideChange", this.update);
      } else {
        const itemIds = [];

        this.getVisibleNotLoaded().forEach((el) => {
          itemIds.push(el.dataset.itemId);

          this.getByItemId(el.dataset.itemId).forEach((el) => {
            el.classList.add("loaded");
          });
        });

        if (itemIds.length) {
          this.loadItems({ itemIds, carouselId: this.carouselId, listName: this.listName });
        }
      }
    }
  };
}

export { CarouselLoadIE };
